import { render } from "./CookiesCountryBanner.vue?vue&type=template&id=8a885db0&scoped=true"
import script from "./CookiesCountryBanner.vue?vue&type=script&lang=js"
export * from "./CookiesCountryBanner.vue?vue&type=script&lang=js"

import "./CookiesCountryBanner.vue?vue&type=style&index=0&id=8a885db0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a885db0"],['__file',"CookiesCountryBanner.vue"]])

export default __exports__